const generateRequestKey = () => {
  if (typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return Array.from(crypto.getRandomValues(new Uint8Array(16)), (byte) =>
    byte.toString(16).padStart(2, '0'),
  ).join('');
};

//* 서버는 키가 다르면 새 참여로 보고 포인트를 또 뺀다 — 확정 응답을 받기 전까지는 같은 키를 돌려준다.
export const createRouletteRequestKey = (
  createKey: () => string = generateRequestKey,
) => {
  let pendingKey: string | null = null;

  return {
    acquire: () => {
      pendingKey ??= createKey();

      return pendingKey;
    },
    confirm: () => {
      pendingKey = null;
    },
  };
};
